import React from "react";
import { RevealOnScroll } from "../../marketingAgency/shared";
import { PROBLEM_PROOF_BRIDGE } from "./problemProofBridgeContent";

const ProblemProofBridgeSection = () => (
  <section
    className="relative overflow-hidden border-t border-partner py-10 sm:py-12"
    data-testid="problem-proof-bridge"
  >
    <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
      <RevealOnScroll>
        <p className="font-mono text-[10px] sm:text-xs text-partner-accent font-semibold tracking-wider mb-3">
          {PROBLEM_PROOF_BRIDGE.label}
        </p>
        <h3 className="text-xl sm:text-2xl font-bold text-partner leading-tight mb-3">
          {PROBLEM_PROOF_BRIDGE.headline}
        </h3>
        <p className="text-sm sm:text-base text-partner-muted font-body leading-relaxed">
          {PROBLEM_PROOF_BRIDGE.body}
        </p>
      </RevealOnScroll>
    </div>
  </section>
);

export default ProblemProofBridgeSection;
